import api from './api';

const workflowStagesService = {
  // Get all workflow stages for the authenticated agent
  getStages: async () => {
    try {
      const response = await api.get('/workflow-stages');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch workflow stages:', error);
      throw error;
    }
  },

  // Create a new workflow stage
  createStage: async (stageData) => {
    try {
      const response = await api.post('/workflow-stages', stageData);
      return response.data.data;
    } catch (error) {
      console.error('Failed to create workflow stage:', error);
      throw error;
    }
  },

  // Update an existing workflow stage
  updateStage: async (stageId, stageData) => {
    try {
      const response = await api.put(`/workflow-stages/${stageId}`, stageData);
      return response.data.data;
    } catch (error) {
      console.error('Failed to update workflow stage:', error);
      throw error;
    }
  },

  // Delete a workflow stage
  deleteStage: async (stageId) => {
    try {
      const response = await api.delete(`/workflow-stages/${stageId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete workflow stage:', error);
      throw error;
    }
  },

  // Move client to a different stage
  moveClient: async (clientId, stageId, reason = null) => {
    try {
      const response = await api.post('/workflow-stages/move-client', {
        client_id: clientId,
        stage_id: stageId,
        reason
      });
      return response.data;
    } catch (error) {
      console.error('Failed to move client to new stage:', error);
      throw error;
    }
  },

  // Get client stage history
  getClientHistory: async (clientId) => {
    try {
      const response = await api.get(`/workflow-stages/client/${clientId}/history`);
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch client stage history:', error);
      throw error;
    }
  }
};

export default workflowStagesService;
